import { MainRouter } from "./routers/MainRouter";

function App() {
    return <MainRouter />;
}

export default App;
